module.exports = __webpack_public_path__ + "static/img/default-user-cover-001.7de4da56.jpg";